<template>
  <div>
    <md-table v-if="$store.state.pageLoaded" class="small-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" v-on:click="editCreateDialogVisible = true; createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptyStage))" title="Dodaj pozornicu" v-if="$store.state.schema.stage.create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Pozornice</h1>
        </div>
      </md-table-toolbar>

      <md-table-row>
        <md-table-head>Naziv</md-table-head>
        <md-table-head class="t-align-center">Akcije</md-table-head>
      </md-table-row>

      <md-table-row md-selectable="single" md-auto-select v-for="item in $store.state.receivedData.stages.list" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item))">
        <md-table-cell>{{ item.title }}</md-table-cell>
        <md-table-cell class="actions-cell">
          <md-button class="md-icon-button md-accent" v-on:click="deleteDialog = true" title="Obriši" v-if="$store.state.schema.stage.delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="editCreateDialogVisible = true; editDialog = true;" title="Uredi" v-if="$store.state.schema.stage.update">
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje pozornice"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" v-if="$store.state.selectedObject !== undefined" class="md-scrollbar">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('title', $store.state.selectedObject)">
              <label>Naziv</label>
              <md-input required type="text" v-model="$store.state.selectedObject.title"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('title', $store.state.selectedObject)">
              <label>Vrsta pozornice</label>
              <md-select v-model="$store.state.selectedObject.kind">
                <md-option v-for="stage, key in $store.state.stageKinds" :value="key">{{ stage }}</md-option>
              </md-select>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="createOrUpdate" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>
  </div>
</template>

<script>
import ListingMixin from '../../../mixins/listing-mixin.js'

export default {
  name: 'Stages',
  data(){
    return {
      emptyStage: {
        title: '',
        kind: '1',
      },
      requiredFields: ['title'],
    }
  },
  mixins: [ListingMixin('stages', 'pozornicu')],
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/Tickets/Stages.vue